import './styles.scss';

import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { Typography } from 'antd';

type Props = {
  label: string;
  text: string;
  onChangeText: (text: string) => void;
  maxLength?: number;
  minLength?: number;
  message?: {
    type: 'error' | 'success' | 'info';
    text: string;
  };
  name?: string;
  disabled?: boolean;
};

const TextArea: React.FC<Props> = ({
  label,
  text,
  onChangeText,
  maxLength,
  minLength,
  message,
  name,
  disabled = false,
}) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const [focused, setFocused] = useState(false);

  const onChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    textAreaRef.current!.style.height = `${
      textAreaRef.current!.scrollHeight
    }px`;
    onChangeText(event.target.value);
  };

  useEffect(() => {
    if (textAreaRef.current!.scrollHeight)
      textAreaRef.current!.style.height = `${
        textAreaRef.current!.scrollHeight
      }px`;
    else if (textAreaRef.current!.scrollHeight === 0)
      textAreaRef.current!.style.height = `auto`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, textAreaRef.current?.scrollHeight]);

  return (
    <div className="customInput">
      <div
        onClick={() => {
          if (!disabled) {
            setFocused(true);
          }
          textAreaRef.current?.focus();
        }}
        className={`input__container ${
          focused ? 'input__container--focused' : ''
        } ${text.length > 0 ? 'input__container--filled' : ''} ${
          disabled ? 'input__container--disabled' : ''
        }`}>
        <label className="input__label">{label}</label>
        <textarea
          ref={textAreaRef}
          name={name}
          disabled={disabled}
          className="input__field input__field--textarea"
          value={text}
          onChange={onChangeHandler}
          maxLength={maxLength}
          minLength={minLength}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
        {maxLength ? (
          <div className="input__counter">
            <Typography.Text className="input__counter__text">
              {text.length}/{maxLength}
            </Typography.Text>
          </div>
        ) : null}
      </div>
      {message ? (
        <Typography.Paragraph
          className={`input__message input__message--${message.type}`}>
          {message.text}
        </Typography.Paragraph>
      ) : null}
    </div>
  );
};

export default React.memo(TextArea);
